import request from '@/axios/axios'

// 授权信息列表
export function getList(query) {
  return request({
    url: 'mqtt/supplier/authorization/page',
    method: 'post',
    data: query
  })
}

// 新增供应商授权信息表
export function addAuthorization(query) {
  return request({
    url: 'mqtt/supplier/authorization/add',
    method: 'post',
    data: query
  })
}

// 编辑供应商授权信息表
export function updateAuthorization(query) {
  return request({
    url: 'mqtt/supplier/authorization/update',
    method: 'post',
    data: query
  })
}

// 通过id删除供应商授权信息表
export function deleteAuthorization(query) {
  return request({
    url: 'mqtt/supplier/authorization/delete',
    method: 'get',
    params: query
  })
}
